import { Td, Tr } from '@cad-arc';
import React, { useEffect, useRef } from 'react';
import { getCrossStreetsString } from '../../helpers/location-display';
import { LocationStoreView } from '../../types/locations';
import { LocationStore } from '../../location-store';
import { LocationSelectDispatchAreaDisplay } from '../common/location-select-dispatch-area-display';
import { HighlightedText } from '../../../common/components/highlighted-text';
import { LocationSelectFormattedLocationDisplay } from '../common/location-select-formatted-location-display';
import { Tooltip } from '../../../common/components/tooltip';
import { CommonSize, getOneSizeSmaller } from '../../../common/helpers/utils';

interface AddressRowProps {
    row: LocationStoreView;
    query: string;
    onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    index: number;
    store: LocationStore;
    size?: CommonSize;
}

export const LocationTableAddressRow: React.FC<AddressRowProps> = ({
    row,
    onClick,
    query,
    store,
    index,
    size,
}) => {
    const ref = useRef<HTMLTableRowElement | null>(null);

    useEffect(() => {
        if (
            ref.current &&
            store.highlightedLocationIndex === index &&
            store.shouldScrollLocationList
        ) {
            ref.current.scrollIntoView(false);
        }
    }, [store.highlightedLocationIndex, index, store.shouldScrollLocationList]);

    const smallerSize = getOneSizeSmaller(size);

    return (
        <Tr
            onMouseEnter={() => {
                store.setHighlightedLocationIndex(index, { source: 'mouse' });
            }}
            style={{
                backgroundColor:
                    index === store.highlightedLocationIndex
                        ? 'var(--arc-colors-interactive-hover)'
                        : undefined,
            }}
            data-testid={`address-row-${row.id}`}
            key={row.id}
            onMouseDown={(e) => onClick(e)}
            ref={ref}
        >
            <Td key="address">
                <LocationSelectFormattedLocationDisplay
                    location={row}
                    query={query}
                    size={smallerSize}
                />
            </Td>

            <Td key="d-area">
                <LocationSelectDispatchAreaDisplay location={row} size={size} />
            </Td>

            <Td key="cross-streets">
                <Tooltip overlay={getCrossStreetsString(row, true)}>
                    <HighlightedText
                        fontSize={smallerSize}
                        matchPattern={query}
                        color="text.secondary"
                        noOfLines={1}
                    >
                        {getCrossStreetsString(row, true)}
                    </HighlightedText>
                </Tooltip>
            </Td>
        </Tr>
    );
};
